<template>
  <div class="wrapper_reco bg-red" id="appli_reco">
    <BtnClose />
    <Accueil v-if="current_page == 'accueil'" />
    <Questions v-if="showQuestions" />
    <Results v-if="showResults" :key="componentKey" />
  </div>
</template>

<script>
// import pour utiliser les mutations et les states du store
import { mapState } from "vuex";
import store from "./store";
import Accueil from "./components/Accueil";
import BtnClose from "./components/BtnClose";
import Questions from "./components/Questions";
import Results from "./components/Results";

export default {
  store,
  data() {
    return {
      resultsQuestions: [
        8,
        9,
        58,
        59,
        71,
        72,
        73,
        74,
        100,
        101,
        171,
        172,
        173,
        174
      ]
    };
  },
  components: {
    Questions,
    BtnClose,
    Accueil,
    Results
  },
  // computed permet d'afficher, utiliser les valeurs du store
  computed: {
    ...mapState([
      "current_page",
      "current_question",
      "loading",
      "componentKey"
    ]),
    showQuestions() {
      const { resultsQuestions, current_page, current_question } = this;
      return (
        !resultsQuestions.includes(current_question) &&
        current_page !== "accueil"
      );
    },
    showResults() {
      const { resultsQuestions, current_page, current_question } = this;
      return (
        resultsQuestions.includes(current_question) &&
        current_page !== "accueil"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
$red: #f52246;

.wrapper_reco {
  //overflow: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
  position: fixed;
  z-index: 50;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 375px;
  height: 100vh;
  max-height: 660px;
  text-align: center;
  box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.25);

  ul {
    list-style-type: none;
  }

  li {
    text-align: left;
  }

  // mini téléphones
  @media screen and (max-width: 340px) and (max-height: 570px) {
    max-height: 100vh;
    max-width: 100%;
  }
}

.bg-img:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  background: linear-gradient(151deg, rgba(0, 0, 0, 0), #000000 79%);
}

.title {
  max-width: 280px;
  margin: 20px auto 40px auto;
  font-size: 18px;
  line-height: 1.36;
  letter-spacing: -0.17px;
  font-weight: bold;
  font-family: helvetica, arial, sans-serif;
}

/* ecran 2 */
.ecran_2 {
  padding: 20px 0 0 0;
}
</style>

<style lang="scss">
.toaster_reco {
  position: fixed;
  right: 40px;
  bottom: 80px;
  z-index: 100;
}
</style>
